import ormInteractionEvents from './interaction';

export default {
    __init__: [],
    interactionEvents: [ 'type', ormInteractionEvents ]
};